import React from 'react'
import PropTypes from 'prop-types'

function EmptyState({text}) {
  return (
    <div data-testid="uebersicht__emptyState">
      <div className="uebersicht__emptyText">{text}</div>
    </div>
  )
}

EmptyState.propTypes = {
  text: PropTypes.string.isRequired,
}

export default EmptyState
